import { ReflectionComponentType } from "@/constants"

const isLikertComponent = (type: string) =>
    type === ReflectionComponentType.COLORED_LIKERT_GROUP || type === ReflectionComponentType.LIKERT_GROUP
const isLikertDefaultComponent = item => "options" in item
const isFreeResponse = (type: string) => type === ReflectionComponentType.FREE_RESPONSE

export { isLikertComponent, isFreeResponse, isLikertDefaultComponent }
